import { SET_LOGGED_IN_USER, SET_CRM_USER } from "../actionTypes";

const initialState = JSON.parse(localStorage.getItem('loggedInUser'))

const loggedInUser = (state = initialState, action) => {
  if (action.type === SET_LOGGED_IN_USER) {
    const { user } = action.payload
    localStorage.setItem('loggedInUser', JSON.stringify(user))
    return user
  }
  else if (action.type === SET_CRM_USER) {
    const { crmUser } = action.payload
    const user = {...state, crmUser}

    localStorage.setItem('loggedInUser', JSON.stringify(user))
    return user
  }
  return state
}


export default loggedInUser;
